<template>
   <CRUDList
      ref="crudList"
      noResultOverride="No status codes found"
      :canAdd="false"
      :canEdit="false"
      :canSave="false"
      :showSelect="false"
      :displayTopPagination="false"
      :hideDefaultFooter="true"
      :enableFixedHeaders="true"
      :disableKeyboardFunc="false"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      :dataMapper="applyAlertOnTaxRecord"
      tableWrapperDynamicClassname='taxroll-table-wrapper-two'
      tableDynamicHeight='80'
      @emitSelectedItem="emitSelectedItem"
    >
    </CRUDList>
</template>
<script>
import {
  mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { StatusCodesHeader } from '../../TaxInquiryUtils/TableHeaders.utils';
import '../../../../../assets/style.css';

export default {
  name: 'TaxRollStatusCodes',
  components: {
    CRUDList,
  },
  props: {
    statusCode: Number,
  },
  data() {
    return {
      baseCrudKey: 'TaxRollStatusCodes',
      headers: StatusCodesHeader,
    };
  },
  destroyed() {
  },
  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.taxFee.selectedItemsStatusCodes,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItemsStatusCodes(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('tax/taxFee', [
      'setSelectedItemsStatusCodes',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    // A status code flagged "Alert on tax record" in the shared list pulses here so it
    // catches the user's eye. crudRowCssAppend is CRUDRow's per-item cell class hook,
    // so only the flagged rows animate - the rest of the panel renders as before.
    applyAlertOnTaxRecord(items) {
      return (items || []).map((item) => {
        if (!item.alertOnTaxRecord) return item;
        const existingClasses = item.crudRowCssAppend || [];
        return { ...item, crudRowCssAppend: [...existingClasses, 'alert-on-tax-record'] };
      });
    },
  },
};
</script>
